// extracted by mini-css-extract-plugin
module.exports = {"imgHeaderBack":"gooses_imgHeaderBack__kXyQi","mainGoose_view":"gooses_mainGoose_view__3B2Hw","lasers_view":"gooses_lasers_view__3IZuO","fire_laser":"gooses_fire_laser__33Sn1"};